export default {
  addEventDialog: (state) => { return state.addEventDialog },
  closeEventDialog: (state) => { return state.closeEventDialog },
  eventDutiesDialog: (state) => { return state.eventDutiesDialog },
  eventPartnersDialog: (state) => { return state.eventPartnersDialog },
  eventTranslatorsDialog: (state) => { return state.eventTranslatorsDialog },
  eventCurrentManagers: (state) => (eventId) =>  { return state.eventsCurrentManagers[eventId] },
  // eventMapCenters: (state) => (eventId) =>  { return state.eventsMapCenters[eventId] },
  types: (state, getters, rootState) => {
    if (!Array.isArray(rootState.entities.eventTypesList)) {
      return [];
    }
    return rootState.entities.eventTypesList.map(id => rootState.entities.eventTypes[id]);
  },

  userEventRoles: (state, getters, rootState) => (userId) => {
    if (!userId) {
      return [];
    }

    let user = rootState.entities.users[userId];

    if (!user || !Array.isArray(user.roles)) {
      return [];
    } else {
      return user.roles.filter(item => {
        return item.isDutyRole;
      })
    }
  },

  typeSubTypes: ((state, getters, rootState) => (type) => {
    if (!Array.isArray(rootState.entities.eventSubTypesList)) {
      return [];
    }
    return rootState.entities.eventSubTypesList
    .map(id => rootState.entities.eventSubTypes[id])
    .filter(item => item.eventType === type);
  }),

  activeEvents: (state, getters, rootState) => {
    return Object.values(rootState.entities.events).filter(item => {
      return (item && item.endDate === null)
    })
  },
  archiveView: (state) => { return state.archiveView },
  eventPageLayout: (state) => { return state.eventPageLayout },
  eventPageLayouts: (state) => { return state.eventPageLayouts },
  eventPageLayoutSizes: (state) => { return state.eventPageLayoutSizes },
  showAllEvents: (state) => { return state.showAllEvents },
  eventIdsToShow: (state) => { return state.eventIdsToShow },
  isCyclingMode: (state) => { return state.isCyclingMode },
  currentEventIndex: (state) => { return state.currentEventIndex },
  cyclingInterval: (state) => { return state.cyclingInterval },
  partnersForAllEvents: (state) => { return state.partnersForAllEvents },
  translatorsForAllEvents: (state) => { return state.translatorsForAllEvents },
};


// WEBPACK FOOTER //
// ./src/store/events/getters.js